




























































































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import Contact from "@/models/contact";
import { LayoutModule } from "@/store/layout";
import { QueryParams, Select } from "@/models/general";
import FormValidations from "@/helpers/validations";
import CompanyAPI from "@/services/companies";
import Company from "@/models/company";

@Component
export default class ContactForm extends Vue {
  @Prop({ default: "contacts.new_contact" }) title!: string;
  @Prop() initialContact?: Contact;

  contact: Contact = new Contact();
  companies: Company[] = [];
  formValidations = new FormValidations();

  languageList: Select[] = [
    {
      text: this.$t("general.spanish").toString(),
      value: "es",
    },
    {
      text: this.$t("general.english").toString(),
      value: "en",
    },
  ];

  get loaderIsVisible(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  created(): void {
    if (this.initialContact) this.contact = new Contact(this.initialContact);

    this.getCompanies();
  }

  async getCompanies(): Promise<void> {
    LayoutModule.showLoader();
    const params: QueryParams = {
      page: {
        size: -1,
      },
    };
    const r = await CompanyAPI.getCompanies(params);
    this.companies = r.data;
    LayoutModule.hideLoader();
  }

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
    validForm ? this.save() : null;
  }

  @Emit()
  save(): Contact {
    return this.contact;
  }

  @Emit()
  cancel(): null {
    return null;
  }
}
